
const layoutContext = require.context('../layout', false, /\index.vue$/)
const viewsContext = require.context('../views', true, /\.vue$/)
export const dataComponentTrans = (data) => {
  // 所有的页面路径和对应的组件
  let pages = {};
  layoutContext.keys().forEach(key => {
    pages[key] = layoutContext(key).default
  })
  viewsContext.keys().forEach(key => {
    pages[key] = viewsContext(key).default;
  })
  data.forEach(item => {
		item.component = pages[item.component]
		if (item.children) {
			dataComponentTrans(item.children)
		}
  })
}
// 将菜单树形数组转为一维数组并筛选出component为./index.vue的数据
export const jsonToArray =(nodes) => {
  var r=[]
  if (Array.isArray(nodes)) {
    for (var i=0, l=nodes.length; i<l; i++) {
      r.push(nodes[i]); // 取每项数据放入一个新数组
      if (Array.isArray(nodes[i]["children"]) && nodes[i]["children"].length > 0) {
        // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
        r = r.concat(jsonToArray(nodes[i]["children"]))
      }
    }
  } 
  return r
}

// 筛选所有名字为index.vue的组件的对象
export const filterIndexVue = (data) => {
  const list = data.filter(item => {
    return item.component === './index.vue'
  })
  return list
}

// 递归删除树形数据chindren名字大于3的
export const jsonToArrayDel = (nodes) => { 
  var listArray = []
  if (Array.isArray(nodes)) { 
    for (var i = 0, l = nodes.length; i < l; i++) {
      listArray.push(nodes[i]) // 取每项数据放入一个新数组
        if (Array.isArray(nodes[i]['children']) && nodes[i]['children'].length > 0) {
        // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
        listArray = listArray.concat(jsonToArrayDel(nodes[i]['children']))
        // 删除大于3的children
        if(nodes[i].name.split('/').length > 3){
          delete nodes[i]['children']
        }
      }
    }
  }
  return listArray
}

// 数组对象去重复
export const uniqueList = (arr, key = 'id') => {
  const map = new Map()
  arr.forEach(item => map.set(item[key], item))
  return Array.from(map.values())
}

// 删除掉层级大于2的对象
export const trimTreeExceedThreeLevels = (treeData) => {
  // 深拷贝原始数据避免污染原数组
  const clonedData = JSON.parse(JSON.stringify(treeData))

  /**
   * 递归处理节点
   * @param {Array} nodes 当前层节点
   * @param {number} currentLevel 当前层级（根节点为1级）
   */
  const processNodes = (nodes, currentLevel = 1) => {
    nodes.forEach(node => {
      // 如果当前层级 >= 3，直接删除 children
      if (currentLevel >= 2) {
        delete node.children
      } 
      // 否则继续递归处理子节点（层级+1）
      else if (node.children && node.children.length) {
				processNodes(node.children, currentLevel + 1)
			}
    })
  }

  processNodes(clonedData)
  return clonedData
}


// WEBPACK FOOTER //
// ./src/router/routePathTrans.js